import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { Button } from "./ui/button";

const NAV = [
  { label: "Services", href: "#services", testId: "nav-link-services" },
  { label: "How It Works", href: "#how-it-works", testId: "nav-link-how-it-works" },
  { label: "Pricing & Blocks", href: "#pricing", testId: "nav-link-pricing" },
  { label: "Portfolio", href: "#portfolio", testId: "nav-link-portfolio" },
  { label: "Realtor Partner", href: "#realtors", testId: "nav-link-realtors" },
];

export const Header = ({ onBook, onConsult }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 border-b ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-brand-gold/20 shadow-sm" : "bg-white/70 backdrop-blur-md border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-[72px]">
        <a href="#top" aria-label="Pack 2 Perfection home"><Logo /></a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} data-testid={n.testId}
               className="text-sm font-medium text-brand-slate hover:text-brand-cerulean transition-colors">
              {n.label}
            </a>
          ))}
          <Link to="/admin" data-testid="nav-link-owner-console"
                className="text-sm font-medium text-brand-slate hover:text-brand-cerulean transition-colors">
            Owner Console
          </Link>
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Button variant="outline" data-testid="header-cta-consultation" onClick={onConsult}
                  className="border-brand-gold text-brand-goldHover hover:bg-brand-goldSoft rounded-full">
            Get Free Estimate
          </Button>
          <Button data-testid="header-cta-book-now" onClick={onBook}
                  className="brand-gold-shine bg-brand-cerulean hover:bg-brand-ceruleanDark text-white rounded-full">
            Book Service Block
          </Button>
        </div>

        <button className="lg:hidden text-brand-navy" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-brand-gold/20 px-4 py-4 space-y-3">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} onClick={() => setOpen(false)}
               className="block text-brand-navy font-medium py-1.5">{n.label}</a>
          ))}
          <Link to="/admin" className="block text-brand-navy font-medium py-1.5">Owner Console</Link>
          <div className="flex flex-col gap-2 pt-2">
            <Button variant="outline" data-testid="mobile-cta-consultation"
                    onClick={() => { setOpen(false); onConsult(); }}
                    className="border-brand-gold text-brand-goldHover rounded-full">Get Free Estimate</Button>
            <Button data-testid="mobile-cta-book-now" onClick={() => { setOpen(false); onBook(); }}
                    className="bg-brand-cerulean text-white rounded-full">Book Service Block</Button>
          </div>
        </div>
      )}
    </header>
  );
};
